import { Modal } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import HeadsetMicIcon from "@material-ui/icons/HeadsetMic";
import {
  ButtonCancel,
  ButtonSave,
  CloseIconStyle,
  DialogHeader,
  DialogStyle,
} from "../modal/Modal";
import whatsappLogo from "../../assets/icons/whatsapp-logo.webp";

const DialogContainer = styled(DialogStyle)`
  width: 520px;
  max-width: 92vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const CompactHeader = styled(DialogHeader)`
  padding: 14px 20px 0 20px;
  font-size: 18px;
  line-height: 24px;

  .row {
    padding-bottom: 8px;
  }
`;

const Body = styled.div`
  padding: 10px 20px;
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
`;

const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

const SectionCard = styled.div`
  background: #f7f9fc;
  border: 1px solid #e8ecf4;
  border-radius: 8px;
  padding: 10px 12px;
`;

const SectionTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #0a73db;
  margin-bottom: 8px;
`;

const ContactList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const ContactRow = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: inherit;
  border-radius: 6px;
  padding: 2px 0;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: rgba(10, 115, 219, 0.06);
  }
`;

const IconBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  min-width: 26px;
  border-radius: 50%;
  background: ${(props) => props.background || "#e7eefe"};
  color: ${(props) => props.color || "#0036B3"};

  .MuiSvgIcon-root {
    font-size: 14px;
  }
`;

const ContactText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const ContactLabel = styled.span`
  font-size: 11px;
  color: #7e899e;
  line-height: 1.15;
`;

const ContactValue = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #364461;
  line-height: 1.25;
  word-break: break-word;
`;

const SupportCard = styled(SectionCard)`
  background: linear-gradient(135deg, #f0f6ff 0%, #e7eefe 100%);
  border-color: #d6e5ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

const SupportHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1 auto;
  min-width: 180px;
`;

const SupportCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const SupportTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #364461;
`;

const SupportDescription = styled.div`
  font-size: 12px;
  color: #7e899e;
  line-height: 1.3;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px 20px 16px 20px;
  flex-shrink: 0;
`;

const CompactButton = styled(ButtonSave)`
  height: 34px;
  padding: 6px 16px;
  font-size: 13px;
  white-space: nowrap;
`;

const CompactCancel = styled(ButtonCancel)`
  height: 34px;
  padding: 6px 16px;
  font-size: 13px;
`;

const ContactSection = ({ title, phone, whatsapp, email }) => (
  <SectionCard>
    <SectionTitle>{title}</SectionTitle>
    <ContactList>
      <ContactRow href={`tel:${phone.replace(/\D/g, "")}`}>
        <IconBadge>
          <PhoneIcon />
        </IconBadge>
        <ContactText>
          <ContactLabel>Telefone Fixo</ContactLabel>
          <ContactValue>{phone}</ContactValue>
        </ContactText>
      </ContactRow>

      <ContactRow
        href={`https://wa.me/55${whatsapp.replace(/\D/g, "")}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <IconBadge background="#e8f8ef" color="#1fa855">
          <img src={whatsappLogo} alt="WhatsApp" width={30} height={30} />
        </IconBadge>
        <ContactText>
          <ContactLabel>WhatsApp</ContactLabel>
          <ContactValue>{whatsapp}</ContactValue>
        </ContactText>
      </ContactRow>

      <ContactRow href={`mailto:${email}`}>
        <IconBadge background="#fff4e8" color="#e67e22">
          <EmailIcon />
        </IconBadge>
        <ContactText>
          <ContactLabel>E-mail</ContactLabel>
          <ContactValue>{email}</ContactValue>
        </ContactText>
      </ContactRow>
    </ContactList>
  </SectionCard>
);

export const HelpDialog = ({ open, onClose, onOpenSupport }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="help-dialog-title"
      aria-describedby="help-dialog-description"
    >
      <DialogContainer>
        <CompactHeader>
          <div className="row">
            <div id="help-dialog-title">Ajuda</div>
            <CloseIconStyle onClick={onClose} />
          </div>
        </CompactHeader>

        <Body id="help-dialog-description">
          <Sections>
            <ContactGrid>
              <ContactSection
                title="SAC"
                phone="(19) 4040-4800"
                whatsapp="(19) 4040-4800"
                email="sac@qyon.com.br"
              />

              <ContactSection
                title="Financeiro"
                phone="(19) 4040-4800"
                whatsapp="(19) 4040-4800"
                email="financeiro@qyon.com"
              />
            </ContactGrid>

            <SupportCard>
              <SupportHeader>
                <IconBadge background="#0036B3" color="#fff">
                  <HeadsetMicIcon />
                </IconBadge>
                <SupportCopy>
                  <SupportTitle>Suporte Técnico</SupportTitle>
                  <SupportDescription>
                    Atendimento técnico em tempo real.
                  </SupportDescription>
                </SupportCopy>
              </SupportHeader>
              <CompactButton onClick={onOpenSupport}>Clique aqui</CompactButton>
            </SupportCard>
          </Sections>
        </Body>

        <Footer>
          <CompactCancel onClick={onClose}>Fechar</CompactCancel>
        </Footer>
      </DialogContainer>
    </Modal>
  );
};
